'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

// TODO: Change this to building blocks to remove the necessity of declaring
// renderCta, renderPara, etc.

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      { level: '3', className: 'link-panel__headline pp-sans-small-regular h4' },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderItems = function renderItems(items, properties) {
  if (items) {
    var links = items.map(function (item, idx) {
      var result = [];
      result.push(_react2.default.createElement(
        'li',
        { className: 'link-panel__link', key: idx },
        _react2.default.createElement(
          'a',
          {
            href: item.link.href,
            target: item.link.target,
            'data-pa-click': '' + properties.name + properties.pnlIdx + '-Link' + idx + '-' + item.link.text
          },
          item.link.text
        )
      ));

      if (item.description) {
        result.push(_react2.default.createElement(
          'li',
          { className: 'link-panel__description' },
          _react2.default.createElement(
            'p',
            null,
            htmlToReactParser.parse(item.description.text)
          )
        ));
      }
      return result;
    });

    return _react2.default.createElement(
      'ul',
      { className: 'link-panel__list' },
      links
    );
  }
  return null;
};

var LinkPanel = function LinkPanel(props) {
  var _props$content = props.content,
      items = _props$content.items,
      headline = _props$content.headline;


  var moleculeClasses = (0, _classnames2.default)('link-panel', props.className);

  return _react2.default.createElement(
    'div',
    { className: moleculeClasses },
    renderHeadline(headline),
    renderItems(items, props)
  );
};

exports.default = LinkPanel;


LinkPanel.propTypes = {
  /* eslint-disable-next-line react/no-unused-prop-types */
  config: _propTypes2.default.shape({
    type: _propTypes2.default.string
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }), // isVisible
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      link: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string.isRequired,
        target: _propTypes2.default.oneOf(['_self', '_blank'])
      }).isRequired,
      description: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    })).isRequired
  }),
  className: _propTypes2.default.string
};

LinkPanel.defaultProps = {
  config: {
    type: 'LinkPanel'
  },
  content: {
    headline: {
      text: '44 characters maximum'
    },
    items: [{
      link: {
        text: '35 characters maximum for each link',
        href: '#',
        target: '_blank'
      },
      description: {
        text: '30 characters maximum'
      }
    }, {
      link: {
        text: '35 characters maximum for each link',
        href: '#',
        target: '_blank'
      },
      description: {
        text: '30 characters maximum'
      }
    }, {
      link: {
        text: '35 characters maximum for each link',
        href: '#',
        target: '_blank'
      },
      description: {
        text: '30 characters maximum'
      }
    }, {
      link: {
        text: '35 characters maximum for each link',
        href: '#',
        target: '_blank'
      },
      description: {
        text: '30 characters maximum'
      }
    }]
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/molecules/link-panel/jsx/LinkPanel.js
// module id = 565
// module chunks = 4